/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuyAltArtResponse } from '../../models/buy-alt-art-response';

export interface AltArtServiceBuyAltArt$Params {
  userUuid: string;
  gachaId: string;
  altArtId: number;
  discordId?: string;
}

export function altArtServiceBuyAltArt(http: HttpClient, rootUrl: string, params: AltArtServiceBuyAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<BuyAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, altArtServiceBuyAltArt.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('gachaId', params.gachaId, {});
    rb.path('altArtId', params.altArtId, {});
    rb.query('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuyAltArtResponse>;
    })
  );
}

altArtServiceBuyAltArt.PATH = '/api/v3/gateway/user/{userUuid}/gacha/{gachaId}/altart/{altArtId}/buy';
